interface MapleLeafProps {
  className?: string
}

export function MapleLeaf({ className }: MapleLeafProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M12 2L9 7.5L3 6L6 10.5L2 15H7L6 19L12 22L18 19L17 15H22L18 10.5L21 6L15 7.5L12 2Z" />
    </svg>
  )
}
